import { Component, OnInit, ViewChild } from '@angular/core';
import { VwSecDependencia } from '../../../../shared/interfaces/database/seguridad';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LocalService, Page } from 'lib-base';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SecDependenciaService } from '../../../../services/database/secDependencia.service';
import { AdminDependenciaUsuariosComponent } from './admin-dependencia-usuarios/admin-dependencia-usuarios.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-dependencias-usuario',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, CustomTableComponent,
    TableModule, ButtonModule, AdminDependenciaUsuariosComponent
  ],
  templateUrl: './dependencias-usuario.component.html',
  styleUrls: ['./dependencias-usuario.component.scss']
})
export class DependenciasUsuarioComponent implements OnInit {
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _sd: SecDependenciaService, private readonly _t: TranslateService, public readonly ls: LocalService) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      dependencia: this._t.get('common.dependencia'),
    }));

    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'descripcion',
          header: this.trans.dependencia,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
      ],
      settings: {
        table: {
          rows: 5,
        }
      }
    } as ICustomTable;
  }

  getDependencias() {
    this._sd.getDependencias().subscribe({
      next: (page: Page<VwSecDependencia>) => {
        this.customTableComponent.data = page.content;
      }
    });
  }
}
